import styles from './sticky-header.module.css';
import { PropsWithChildren, ReactNode, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { Button } from '../form/button';
import Icon from '../icons/icon';
import { Typography } from '../typography/typography';
import { isMobileOnly } from 'react-device-detect';

type StickyHeaderProps = PropsWithChildren<{
  title: ReactNode;
}>;

export const StickyHeader = ({ title, children }: StickyHeaderProps) => {
  const navigate = useNavigate();

  const wrapper = useRef<HTMLDivElement>(null);
  const [wrapperWidth, setWrapperWidth] = useState<number>(0);

  useEffect(() => {
    if (!wrapper.current) return;

    const resizeObserver = new ResizeObserver(() => {
      setWrapperWidth(wrapper.current?.scrollWidth ?? 0);
    });

    resizeObserver.observe(wrapper.current);

    return () => {
      resizeObserver.disconnect();
    }; // clean up
  }, [wrapper.current]);

  return (
    <div ref={wrapper} className="flex">
      <div
        className={classNames(
          'h-[89px] sm:h-[60px] flex flex-col sm:flex-row justify-between sm:items-center pb-[8px] sm:pb-0',
          styles.stickyHeader,
        )}
        style={{
          width: `${wrapperWidth}px`,
        }}
      >
        <div className="flex items-center">
          <Button className="button-tertiary" onClick={() => navigate(-1)}>
            <Icon icon="Back" size="large" />
          </Button>

          <Typography className="text-grey-800" type={isMobileOnly ? 'text-md' : 'text-xl'} weight="semi-bold">
            {title}
          </Typography>
        </div>

        <div className="flex justify-between gap-x-[12px]">{children}</div>
      </div>

      <div className="h-[89px] sm:h-[60px]"></div>
    </div>
  );
};
